import React, { useContext } from "react";
import pptpage from "../Faultanalysis_Bus/Fleet_EV_Fault Analytics_Navigation_Guide2.pdf";
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";
import AppContext from '../../../store/AppContext';

function PPTPage_Fault_Bus() {
  const app_ctx = useContext(AppContext);

  return (
    <>
      <DashboardMain_Bus>
        <iframe src={pptpage} frameborder="0" height="539em" width="100%" sandbox></iframe>
      </DashboardMain_Bus>
    </>
  );
}

export default PPTPage_Fault_Bus;
